/* Archival signup: popup behavior + Klaviyo client subscription (popup and footer forms).
   Only the PUBLIC company id is used (safe in the browser). Nothing here is sent anywhere else. */
(function () {
  'use strict';
  if (window.__aaSignupLoaded) return;
  window.__aaSignupLoaded = true;

  var KEY_UNTIL = 'aa_signup_snooze_until';
  var KEY_DONE = 'aa_signup_done';
  var KEY_SESSION = 'aa_signup_shown';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  /* ---------- Klaviyo submission (shared by popup + footer) ---------- */
  function subscribe(email, company, list, source) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          custom_source: source
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status === 202 || res.status === 200 || res.status === 204) return true;
      throw new Error('klaviyo ' + res.status);
    });
  }

  // like Klaviyo's own forms: tie this browser to the new profile, so browse / cart abandonment flows can reach them right away
  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
      else (window._learnq = window._learnq || []).push(['identify', { $email: email }]);
    } catch (e) {}
  }

  function bindForm(form) {
    if (form.__aaBound) return;
    form.__aaBound = true;
    var input = form.querySelector('input[type="email"]');
    var err = form.querySelector('[data-su-error]');
    var btn = form.querySelector('[type="submit"]');
    var btnLabel = btn && btn.querySelector('span');
    var idleLabel = btnLabel ? btnLabel.textContent : '';
    var busy = false;

    function showErr(msg) {
      if (err) { err.textContent = msg; err.hidden = false; }
      if (input) input.setAttribute('aria-invalid', 'true');
    }
    function clearErr() {
      if (err) { err.textContent = ''; err.hidden = true; }
      if (input) input.removeAttribute('aria-invalid');
    }
    if (input) input.addEventListener('input', clearErr);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showErr(form.getAttribute('data-msg-invalid') || 'please enter a valid email address.');
        input.focus();
        return;
      }
      clearErr();
      busy = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (btnLabel) btnLabel.textContent = form.getAttribute('data-label-sending') || 'sending';
      subscribe(email, form.getAttribute('data-company') || 'TcWas7', form.getAttribute('data-list') || 'R3Yfpx', form.getAttribute('data-source') || 'Archival site')
        .then(function () {
          lsSet(KEY_DONE, '1');
          identify(email);
          form.dispatchEvent(new CustomEvent('aa:signup:success', { bubbles: true }));
        })
        .catch(function () {
          showErr(form.getAttribute('data-msg-error') || 'something went wrong. please try again.');
          input.focus();
        })
        .then(function () {
          busy = false;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (btnLabel) btnLabel.textContent = idleLabel;
        });
    });
  }

  /* ---------- footer inline forms ---------- */
  function initFooterForms() {
    document.querySelectorAll('form[data-aa-klaviyo][data-inline]').forEach(function (form) {
      bindForm(form);
      form.addEventListener('aa:signup:success', function () {
        var wrap = form.closest('[data-aa-klaviyo-wrap]') || form.parentNode;
        var ok = wrap.querySelector('[data-inline-success]');
        form.hidden = true;
        if (ok) { ok.hidden = false; }
      });
    });
  }

  /* ---------- popup ---------- */
  function initPopup(root) {
    var cfg = root.dataset;
    var card = root.querySelector('.aa-su__card');
    var formView = root.querySelector('[data-su-form-view]');
    var okView = root.querySelector('[data-su-success]');
    var form = root.querySelector('form[data-aa-klaviyo]');
    var input = form.querySelector('input[type="email"]');
    var tab = document.querySelector('[data-su-tab]');
    var lastFocus = null;
    var opened = false;
    var loadedAt = Date.now();
    var timers = [];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = cfg.designMode === 'true';
    var forced = /[?&]aa_signup=1\b/.test(location.search);
    var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

    bindForm(form);

    function snoozed() {
      var until = parseInt(lsGet(KEY_UNTIL) || '0', 10);
      return until > Date.now();
    }
    function suppressedPath() {
      var path = location.pathname.toLowerCase();
      return (cfg.suppress || '').split(/[\s,]+/).some(function (p) {
        p = p.trim().toLowerCase();
        return p.charAt(0) === '/' && path.indexOf(p) === 0;
      });
    }
    var blocked = !(design || forced) && (lsGet(KEY_DONE) === '1' || snoozed() || suppressedPath());
    if (blocked) { if (tab) tab.remove(); return; }

    var mobilePdp = cfg.pageType === 'product' && isMobile();
    var pdpMode = cfg.pdpMobile || 'tab';
    if (mobilePdp && pdpMode === 'off' && !(design || forced)) { return; }

    /* focus trap */
    function focusables() {
      return Array.prototype.filter.call(
        card.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && !el.hidden && el.offsetParent !== null && !el.closest('[hidden]'); }
      );
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) { e.preventDefault(); card.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === card)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      else if (!card.contains(a)) { e.preventDefault(); first.focus(); }
    }

    function open(fromUser) {
      if (opened) return;
      if (!fromUser && !(design || forced) && (ssGet(KEY_SESSION) === '1')) return;
      opened = true;
      timers.forEach(clearTimeout);
      removeTriggers();
      ssSet(KEY_SESSION, '1');
      lastFocus = document.activeElement;
      root.hidden = false;
      if (reduce) root.classList.add('is-open'); else requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.classList.add('aa-su-lock');
      document.addEventListener('keydown', onKey, true);
      setTimeout(function () { (okView.hidden ? input : card).focus({ preventScroll: true }); }, reduce ? 0 : 60);
    }

    function close(snooze) {
      if (!opened) return;
      opened = false;
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('aa-su-lock');
      document.removeEventListener('keydown', onKey, true);
      if (snooze && !design) {
        var days = Math.max(1, parseInt(cfg.snoozeDays || '7', 10));
        lsSet(KEY_UNTIL, String(Date.now() + days * 86400000));
      }
      if (tab) tab.hidden = true;
      if (lastFocus && document.contains(lastFocus) && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-su-close]') || e.target.hasAttribute('data-su-backdrop')) close(true);
    });
    form.addEventListener('aa:signup:success', function () {
      formView.hidden = true;
      okView.hidden = false;
      if (tab) { tab.hidden = true; }
      var h = okView.querySelector('[data-su-success-h]');
      if (h) h.focus({ preventScroll: true });
      if (!reduce) { root.classList.remove('is-open'); void root.offsetWidth; root.classList.add('is-open'); }
    });

    /* triggers */
    var scrollHandler = null, exitHandler = null;
    function removeTriggers() {
      if (scrollHandler) window.removeEventListener('scroll', scrollHandler);
      if (exitHandler) document.documentElement.removeEventListener('mouseleave', exitHandler);
      scrollHandler = exitHandler = null;
    }
    function otherDialogOpen() {
      return Array.prototype.some.call(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]'), function (el) {
        if (el === card) return false;
        var cs = window.getComputedStyle(el), r = el.getBoundingClientRect();
        return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0 && r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth;
      });
    }
    function guardedOpen() {
      // never within first 5s, never while another dialog/overlay is already open
      var wait = 5000 - (Date.now() - loadedAt);
      if (wait > 0) { timers.push(setTimeout(guardedOpen, wait + 20)); return; }
      if (document.documentElement.classList.contains('aa-sticky-on') && isMobile()) return;
      if (otherDialogOpen()) { timers.push(setTimeout(guardedOpen, 4000)); return; }
      // skip visitors Klaviyo already knows (subscribers arriving from an email, past signups): no "15% off your first order" for them
      if (!design && !forced && window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        Promise.resolve(window.klaviyo.isIdentified()).then(function (known) { if (!known) open(false); }, function () { open(false); });
        return;
      }
      open(false);
    }

    if (design || forced) { guardedOpen(); return; }

    if (mobilePdp && pdpMode === 'tab') {
      if (tab) {
        timers.push(setTimeout(function () { tab.hidden = false; }, Math.max(5, parseInt(cfg.delay || '8', 10)) * 1000));
        tab.addEventListener('click', function () { open(true); });
      }
      return;
    }
    if (tab) tab.remove();

    var delaySec = mobilePdp ? Math.max(20, parseInt(cfg.pdpDelay || '60', 10)) : Math.max(5, parseInt(cfg.delay || '8', 10));
    timers.push(setTimeout(guardedOpen, delaySec * 1000));

    var depth = parseInt(cfg.scroll || '0', 10);
    if (depth > 0 && !mobilePdp) {
      scrollHandler = function () {
        var doc = document.documentElement;
        var pct = (window.pageYOffset + window.innerHeight) / Math.max(doc.scrollHeight, 1) * 100;
        if (pct >= depth) { window.removeEventListener('scroll', scrollHandler); scrollHandler = null; guardedOpen(); }
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }
    if (cfg.exit === 'true' && !isMobile() && window.matchMedia('(hover: hover)').matches) {
      exitHandler = function (e) { if (e.clientY <= 0) guardedOpen(); };
      document.documentElement.addEventListener('mouseleave', exitHandler);
    }
  }

  function boot() {
    initFooterForms();
    var root = document.querySelector('[data-aa-signup]');
    if (root) initPopup(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
